import IngestReport from '@pluto/ingest-validation-report/IngestReportConnected';
import IngestConfigs from 'Ingest/IngestConfigs/IngestConfigsConnected';
import Landing from 'Landing/Landing';
import MediaOrdersItem from 'MediaOrders/MediaOrdersItem/MediaOrdersItemConnected';
import MediaOrdersList from 'MediaOrders/MediaOrdersList/MediaOrdersListConnected';
import IngestList from 'Ingest/IngestList/IngestListConnected';
import QCManager from 'QCWorkflow/QCManager/QCManagerConnected';
import DeliveryManager from 'QCWorkflow/DeliveryManager/DeliveryManagerConnected';
import DeliveryManagerManifestContainer
    from 'QCWorkflow/DeliveryManager/DeliveryManagerManifest/DeliveryManagerManifestContainer';
import QCJobs from 'QCWorkflow/QCJobs/QCJobsConnected';
import QCTools from 'QCTools/QCToolsConnected';
import UsersList from 'Users/UsersList';
import UserAdd from 'Users/UserAdd/UserAddConnected';
import User from 'Users/UserDetails/UserContainer';
import CreatingNewIngest from 'Ingest/IngestConfigItem/CreatingNewIngest/CreatingNewIngestConnected';
import CreatingContentPartner from 'ContentPartners/CteatingContentPartner/CteatingContentPartnerConnected';
import ContentItemSearched from 'ContentItem/Search/SearchContainer';
import EditingIngestConfig from 'Ingest/IngestConfigItem/EditingIngestConfig/EditingIngestConfigConnected';
import EditingContentPartner from 'ContentPartners/EditingContentPartner/EditingContentPartnerConnected';
import IngestSessionError from 'Ingest/IngestSessionError/IngestSessionErrorConnected';
import IngestData from 'Ingest/IngestData/IngestDataConnected';
// import ContentItem from 'ContentItem/ContentItemConnected';
import ContentItem from 'ContentItemView/ContentItemViewConnected';
import VideoAudioQC from 'VideoAudioQC/VideoAudioQCConnected';
import ContentPartners from 'ContentPartners/ContentPartnersConnected';
import {baseRoutes, adminRoutes} from './routes';
import NotFound from 'NotFound/NotFound';
import {
    MAIN_PAGE,
    SEARCH,
    SEARCH_ITEM,
    ADD_USERS,
    EDIT_INGEST_CONFIG,
    INGEST_CONFIG,
    INGEST_DATA,
    INGEST_REPORT,
    INGEST_SESSION_ERROR,
    MANAGE_INGEST,
    MEDIA_ORDER_ITEM,
    MEDIA_ORDER_LIST,
    NOT_FOUND,
    QC_MANAGER,
    QC_TOOLS,
    DELIVERY_MANAGER,
    QC_WORK_QUEUE,
    USER_DETAILS,
    USERS_LIST,
    VIDEO_QC_PLAYER,
    CREATE_NEW_INGEST,
    CONTENT_PARTNERS,
    EDIT_CONTENT_PARTNER,
    CREATE_CONTENT_PARTNER,
    DELIVERY_MANAGER_MANIFEST,
} from './roleNames';

export const rolesConfig = {
    default: [
        {
            route: baseRoutes.landing,
            component: Landing,
            name: MAIN_PAGE,
        },
        {
            route: baseRoutes.contentItemsSearch,
            component: ContentItemSearched,
            name: SEARCH,
        },
        {
            route: baseRoutes.contentItemsItem,
            component: ContentItem,
            name: SEARCH_ITEM,
        },
    ],
    qcOperator: [
        {
            route: baseRoutes.videoAudioQc,
            component: VideoAudioQC,
            name: VIDEO_QC_PLAYER,
        },
        {
            route: baseRoutes.qcJobs,
            component: QCJobs,
            name: QC_WORK_QUEUE,
        },
        {
            route: baseRoutes.qcJobsTools,
            component: QCTools,
            name: QC_TOOLS,
        },
    ],
    contentOpsCoordinator: [
        {
            route: baseRoutes.ingest,
            component: IngestList,
            name: MANAGE_INGEST,
        },
        {
            route: baseRoutes.ingestData,
            component: IngestData,
            name: INGEST_DATA,
        },
        {
            route: baseRoutes.ingestDataItem,
            component: IngestData,
            name: INGEST_DATA,
        },
        {
            route: baseRoutes.ingestDataItemError,
            component: IngestSessionError,
            name: INGEST_SESSION_ERROR,
        },
        {
            route: baseRoutes.ingestReport,
            component: IngestReport,
            name: INGEST_REPORT,
        },
        {
            route: baseRoutes.mediaOrders,
            component: MediaOrdersList,
            name: MEDIA_ORDER_LIST,
        },
        {
            route: baseRoutes.mediaOrdersItem,
            component: MediaOrdersItem,
            name: MEDIA_ORDER_ITEM,
        },
        {
            route: baseRoutes.qcManager,
            component: QCManager,
            name: QC_MANAGER,
        },
        {
            route: baseRoutes.deliveryManager,
            component: DeliveryManager,
            name: DELIVERY_MANAGER,
        },
        {
            route: baseRoutes.deliveryManagerManifest,
            component: DeliveryManagerManifestContainer,
            name: DELIVERY_MANAGER_MANIFEST,
        },
        {
            route: baseRoutes.qcManagerTools,
            component: QCTools,
            name: QC_TOOLS,
        },
    ],
    admin: [
        {
            route: adminRoutes.ingestConfigs,
            component: IngestConfigs,
            name: INGEST_CONFIG,
        },
        {
            route: adminRoutes.editIngestFeed,
            component: EditingIngestConfig,
            name: EDIT_INGEST_CONFIG,
        },
        {
            route: adminRoutes.newIngestFeed,
            component: CreatingNewIngest,
            name: CREATE_NEW_INGEST,
        },
        {
            route: adminRoutes.contentPartners,
            component: ContentPartners,
            name: CONTENT_PARTNERS,
        },
        {
            route: adminRoutes.editContentPartner,
            component: EditingContentPartner,
            name: EDIT_CONTENT_PARTNER,
        },
        {
            route: adminRoutes.newContentPartner,
            component: CreatingContentPartner,
            name: CREATE_CONTENT_PARTNER,
        },
        {
            route: adminRoutes.users,
            component: UsersList,
            name: USERS_LIST,
        },
        {
            route: adminRoutes.addUser,
            component: UserAdd,
            name: ADD_USERS,
        },
        {
            route: adminRoutes.userDetails,
            component: User,
            name: USER_DETAILS,
        },
        {
            route: adminRoutes.roles,
            component: NotFound,
            name: NOT_FOUND,
        },
    ],
};
